/*==========================================================
HTML CLASSES SCRIPT
==========================================================*/
var topNavAdjust = false;

function checkTopNavMobile() {
  if (topNavAdjust) {
    topNavReset();
  }

  if (
    (Modernizr.mq("only screen and (max-width: 1199px)") && Modernizr.touch) ||
    Modernizr.mq("only all and (max-width: 1199px)")
  ) {
    topNavMobile();
  }
}

function topNavMobile() {
  if (!topNavAdjust) {
    if ($("#topNav").length) {
      $("#topNav")
        .children()
        .detach()
        .appendTo("#nav")
        .wrap('<li class="topNavMobile" />');
    }

    if ($("#browseAloudContainer").length) {
      $("#browseAloudContainer").detach().appendTo("#nav").wrap("<li />");
    }

    if ($("#pageHeading").is("*")) {
      $("#pageHeading").detach().insertBefore(".topContentWrapper");
    } // topContent (pageHeading + subNavTrigger)

    if ($("#subNavWrapper #contactMainContainer").is("*")) {
      $("#subNavWrapper #contactMainContainer")
        .detach()
        .appendTo("#contentInt");
    } // interior contact

    if ($("#subNavWrapper #pageSubscription").is("*")) {
      $("#subNavWrapper #pageSubscription").detach().appendTo("#contentInt");
    } // interior subscribe

    if ($("#subNavWrapper").is("*")) {
      $("#subNavWrapper").detach().prependTo("#contentInt");
    } // interior subNavWrapper

    if ($("#searchPopup .searchContainer").is("*")) {
      $("#searchPopup .searchContainer").detach().appendTo("#mainNav");
    } // search

    if ($("#topNavContainer #idLikeTo").is("*")) {
      $("#topNavContainer #idLikeTo").detach().appendTo("#mainNav");
    } // I'd like to

    topNavAdjust = true;
  }
}

function topNavReset() {
  if (topNavAdjust) {
    topNavAdjust = false;

    if ($("#topNav").length) {
      $(".topNavMobile").children().unwrap("li").detach().prependTo("#topNav");
    }

    if ($("#browseAloudContainer").length) {
      $("#browseAloudContainer").unwrap("li").detach().insertAfter("#topNav");
    }

    if ($("#pageHeading").is("*")) {
      $("#pageHeading").detach().prependTo("#printArea");
    } // topContent (pageHeading + subNavTrigger)
    
    if ($("#subNavWrapper").is("*")) {
      $("#subNavWrapper").detach().prependTo("#main");
    } // interior subNavWrapper

    if ($("#contactMainContainer").is("*")) {
      $("#contactMainContainer").detach().appendTo("#subNavWrapper");
    } // interior contact

    if ($("#pageSubscription").is("*")) {
      $("#pageSubscription").detach().appendTo("#subNavWrapper");
    } // interior subscribe

    if ($("#mainNav .searchContainer").is("*")) {
      $("#mainNav .searchContainer")
        .detach()
        .appendTo("#searchPopup .modal-body");
    } // search

    if ($("#mainNav #idLikeTo").is("*")) {
      $("#mainNav #idLikeTo").detach().appendTo("#topNavContainer");
    } // I'd like to
  }
}

$(window).load(function () {
  checkTopNavMobile();
  $("#gs_tti50 input[class=gsc-input]").attr({placeholder: "What are you looking for?", tabindex: 0 });
});

//debounce resize instead of standard resize
$(window).debounceResize(function () {
  checkTopNavMobile();
});
